import React from "react";
import './Instructions.css';

export const Instructions = () => {
    return (
        <div className="instructions mb20">
            <h2>How to use:</h2>
            <div>
                1. Connect your LinnStrument to your computer.<br />
                2. Select the LinnStrument MIDI port in the MIDI OUT list.<br />
                3. Click the "Enable LinnStrument User Mode" button.
            </div>
            <h2>Formula:</h2>
            <div>
                The formula must be a valid JavaScript expression.
            </div>
            <div className="mt10">
                You can use the following variables in your formula:
            </div>
            <div className="mt10">
                x : column index (0..15 for Linn128, 0..24 for Linn200)<br />
                y : row index (0..7)<br />
                t : time (seconds elapsed since start)<br />
                i : cell index  (0..127 for Linn128, 0..199 for Linn200)<br />
                r : random number between 0 and 1 (change every iteration)
            </div>
            <div className="mt10">
                Try to use a formula that output a value between -1 and +1.
            </div>
            <div className="mt10">
                The color, from the currently chosen colors, is selected with: <br/>
            </div>
            <div className="mt10">
                <code>chosen_colors_index = round((value + 1) / 2 * (number_of_chosen_color - 1))</code>
            </div>
            <div className="mt10">
                You can skip the Math. prefix to use <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math" target="_blank" rel="noreferrer noopener">JS Math</a> constants or functions.
            </div>
            <h2>In case of problem:</h2>
            <div>
                - Refresh the application (reload the page in the browser)<br />
                - Unplug / Re-plug the LinnStrument
            </div>
        </div>
    );
}
